export const APP_CONSTANTS = {
   appName: 'My Next.js App',
   version: '1.0.0',
   copyrightYear: new Date().getFullYear(),
   maxUploadSize: 10 * 1024 * 1024, // 10MB
   supportEmail: 'support@example.com',
   paginationOptions: [10, 25, 50, 100],
   defaultLocale: 'en-US',
};
